import React from 'react';
import { formatDate } from '@common/paymentsUtils/dateUtils';
import { isAfter } from 'date-fns';
import { coerceToDate } from '@common/paymentsUtils/dateUtils';
import { Box, Label, Paragraph, Select, Text, TextButton } from '@zillow/constellation-10';
import Calendar from '@common/components/Calendar';
import dropdownBuilder from '../dropdownBuilder';
import PontoonConstants from '@common/constants/PontoonExceptionConstants';

interface Props {
  startPage?: string;
  dueDate: string;
  today?: Date;
  selectedDate: string;
  changeSelectedDate: (selectedDate: string) => void;
  fromDashboard: boolean;
  onMarkPaid?: () => void;
}

interface State {
  showDropdown: boolean;
}

class RecurringSchedulingPage extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      showDropdown: props.selectedDate !== props.dueDate,
    };
  }

  toggleShowDropdown = () => {
    this.setState({ showDropdown: true });
  };

  changeSelectedDate = (e) => {
    const value = e.target.value;
    this.props.changeSelectedDate(value);
  };

  renderBody = () => {
    const { dueDate, selectedDate, today } = this.props;
    const { showDropdown } = this.state;
    const parsedDueDate = coerceToDate(dueDate) ?? new Date(dueDate as any);
    return (
      <Box>
        {showDropdown ? (
          <>
            <Label>Send date</Label>
            <Select data-id="selectedDate" value={selectedDate} onChange={this.changeSelectedDate}>
              {dropdownBuilder(parsedDueDate, today)}
            </Select>
          </>
        ) : (
          <Box css={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 'token(spacing.sm)' }}>
            <Calendar
              title="Send date"
              dateLine1={formatDate(
                selectedDate,
                'do',
                PontoonConstants.RENTER_HUB.PAYMENTS_SETTINGS.RENT_PAYMENT.DUE_DATE,
              )}
              dateLine2="of the month"
            />
            <TextButton textStyle="body-sm-bold" onClick={this.toggleShowDropdown}>
              Choose a different day
            </TextButton>
          </Box>
        )}
      </Box>
    );
  };

  renderLatePaymentText = () => {
    const { dueDate, selectedDate } = this.props;
    const left = coerceToDate(selectedDate);
    const right = coerceToDate(dueDate);
    return (
      !!left &&
      !!right &&
      isAfter(left, right) && (
        <Text textStyle="body-sm" css={{ color: 'red.600' }}>
          Your chosen date is after the &quot;Due date&quot;, your rent could be considered late. &nbsp; Please contact
          your landlord in advance.
        </Text>
      )
    );
  };

  renderLastDayOfMonthText = () => {
    const { selectedDate } = this.props;
    const selectedDateAsNumber = Number(
      formatDate(selectedDate, 'd', PontoonConstants.RENTER_HUB.PAYMENTS_SETTINGS.RENT_PAYMENT.DUE_DATE),
    );
    const showLastDayOfMonthText = selectedDateAsNumber > 28 && selectedDateAsNumber < 31;
    return (
      showLastDayOfMonthText && (
        <Paragraph textStyle="body-sm">
          We&apos;ll withdraw the rent on the last day of any month with fewer than {selectedDateAsNumber} days.
        </Paragraph>
      )
    );
  };

  render() {
    return (
      <Box css={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 'token(spacing.sm)' }}>
        {this.renderBody()}
        {this.renderLatePaymentText()}
        {this.renderLastDayOfMonthText()}
        <Box>
          <Text textStyle="body-sm">
            We&apos;ll email you a reminder 5 days before your payment is due each month. If this date falls on a
            weekend or holiday, we&apos;ll send the rent&nbsp;
          </Text>
          <Text textStyle="body-sm-bold">1 business day later.</Text>
        </Box>
      </Box>
    );
  }
}

export default RecurringSchedulingPage;
